import styled from "styled-components";

export const NoResults = styled.p`
  font-family: Rubik;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  font-weight: 500;
`;
